module.exports = __webpack_public_path__ + "img/full3-min.00b6f075.png";